<script lang="ts">
	import FlowsListHolder from '../components/Lists/Flows/FlowsListHolder.svelte';
	import { location } from 'svelte-spa-router';

	export let params = { id: '' };
	$: basePath = $location.startsWith('/automation/') ? '/automation/flows' : '/home/flows';
</script>

<FlowsListHolder flowId={params.id} {basePath} />
